import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { PropertyCard } from "@/components/site/PropertyCard";
import { SectionHead } from "@/components/site/Reveal";

export default function Properties() {
  const [items, setItems] = useState(null);
  const [beds, setBeds] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  useEffect(() => { api.get("/properties").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  const list = useMemo(() => (items || []).filter((p) =>
    (!beds || p.bedrooms >= Number(beds)) && (!maxPrice || p.price <= Number(maxPrice))), [items, beds, maxPrice]);

  return (
    <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16 sm:py-20" data-testid="properties-page">
      <SectionHead eyebrow="Available properties" title="Chain-free opportunities across London">
        A small, hand-picked selection that we update as new properties come in. Enquire and we'll handle everything with the seller on your behalf.
      </SectionHead>
      <div className="mt-10 flex flex-wrap gap-3">
        <select data-testid="filter-bedrooms" value={beds} onChange={(e) => setBeds(e.target.value)} className="field-input field-select !w-44">
          <option value="">Any bedrooms</option>
          {[1, 2, 3, 4, 5].map((n) => <option key={n} value={n}>{n}+ bedrooms</option>)}
        </select>
        <select data-testid="filter-max-price" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)} className="field-input field-select !w-48">
          <option value="">Any price</option>
          {[500000, 750000, 1000000, 1500000, 2500000].map((n) => <option key={n} value={n}>Up to £{n.toLocaleString("en-GB")}</option>)}
        </select>
      </div>
      {items === null ? (
        <p className="mt-16 eyebrow">Loading…</p>
      ) : list.length === 0 ? (
        <div className="mt-16 border border-dashed border-[#C5BCAB] p-12 text-center" data-testid="properties-empty">
          <p className="font-display text-2xl">New properties are on their way</p>
          <p className="mt-2 text-sm text-[#57534E]">Register as a buyer and we'll match you as soon as something suitable comes in.</p>
        </div>
      ) : (
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{list.map((p) => <PropertyCard key={p.id} p={p} />)}</div>
      )}
    </div>
  );
}
